// extracted by mini-css-extract-plugin
export default {"Tables":"Tables_Tables__Xiwkb"};